import { Injectable } from '@angular/core';
import { Time } from '@angular/common';
import { DatePipe } from '@angular/common';

  export class TripsArry {
    ID: string;
    DriverReadDate: string;
    FirstDriver: string;
    MethodOfPaymentName: string;
    TabAccName: string;
    Vehicle: string;
    allDayFlag: number;
    cancelled: number;
    confirmedByCustomer: string;
    confirmedByDriver: string;
    customer: string;
    dropOffAddress: string;
    dropOffDate: any;
    dropOffInstructions: string;
    emailAddress: string;
    emailSent: number;
    invoiced: number;
    methodOfPayment_Id: any;
    notesToClient: string;
    numberOfPeople: number;
    paid: number;
    pickUpAddress: string;
    pickUpDate: any;
    pickUpInstructions: string;
    smsSent: number;
    stopsAddress: string;
    tabAccount_ID: any;
    takeTrailor: number;
    vehicle_Id: any;
  }

  export class Product {
    ID: number;
    Name: string;
    Price: number;
    Current_Inventory: number;
    Backorder: number;
    Manufacturing: number;
    Category: string;
    ImageSrc: string;
}

export class MethodOfPayment {
  Id: number;
  Name: string;
}

export class Account {
  ID: number;
  NAME: string;
  email: string;
  contactNumber: string;
}

export class Vehicle {
  Id: number;
  Fullname: string;
}

export class TripExpenses {
  EXPENSENAME: string;
  AMOUNT: number;
  TRIP_ID: string;
}

export class Drivers {
  DRIVER_ID: any;
  TRIP_ID: number;
}

export class TripDrivers {
  DRIVER_ID: number;
  NAME: string;
}

export class TripDriversPostback {
  TRIP_ID: string;
  DRIVER_ID: number;
}

export class CustomerRow {
  name: string;
  cell: string;
}
